import { z } from 'zod';

export interface CoQuanThueFormattedData {
  ma_cqt: string;
  ten_cqt: string;
  ma_cqt0?: string | null;
  status: string;
}

export const searchSchema = z.object({
  ma_cqt: z.string().min(1, 'Mã cơ quan thuế là bắt buộc'),
  ten_cqt: z.string().min(1, 'Tên cơ quan thuế là bắt buộc'),
  ma_cqt0: z.string().optional().nullable(),
  trang_thai: z.number().default(1)
});
export type SearchFormValues = z.infer<typeof searchSchema>;
